import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { eventBus } from 'src/helper/EventBus'

type Refresh = () => void

interface VoidItemReservationParams {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingVoidItem: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmVoid: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenVoidModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const voidItemReservation = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setHashItemReserve,
  setLoadingVoidItem,
  setNameReserve,
  setConfirmVoid,
  setOpenVoidModal,
}: VoidItemReservationParams): Promise<void> => {
  try {
    setLoadingVoidItem(true)
    setOpenVoidModal && setOpenVoidModal(false)
    const status = await itemServices.void_item(hashItemReserve)
    if (status >= 200 && status <= 204) {
      notify('ra.notification.void_item_reserve_success', {
        type: 'success',
        messageArgs: { reserve: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirmVoid && setConfirmVoid(false)
      eventBus.emit('updateBillingStatus', hashItemReserve)
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirmVoid && setConfirmVoid(false)
    notify('ra.notification.void_item_reserve_error', {
      type: 'error',
      messageArgs: { reserve: nameReserve },
    })
  } catch (error) {
    console.log('error', error)
    notify('ra.notification.void_item_reserve_error', {
      type: 'error',
      messageArgs: { reserve: nameReserve },
    })
    setOpenVoidModal && setOpenVoidModal(false)
    setNameReserve('')
    setHashItemReserve('')
    setConfirmVoid && setConfirmVoid(false)
  } finally {
    customAwait([refresh])
    setOpenVoidModal && setOpenVoidModal(false)
    setLoadingVoidItem(false)
  }
}
